import { Copy, ScanSearch, TextSearch } from 'lucide-react'

import { Button } from '@krp/ui-kit'

import type { TestingAccess, TestingHomeActions } from '../model/types'
import { TestingGate } from './TestingParts'

/**
 * Вкладка «Тестирование»: список видов проверок — поиск по фото, поиск по
 * тексту и похожие варианты; новые виды встают сюда же строкой, не меняя меню.
 */
export function TestingHomeScreen({ access, actions }: { access: TestingAccess; actions: TestingHomeActions }) {
  return (
    <TestingGate access={access}>
      <section aria-labelledby="platform-testing-title" className="platform-testing platform-testing--home">
        <h2 id="platform-testing-title">Тестирование</h2>
        <ul className="platform-testing__kinds" aria-label="Виды проверок">
          <li>
            <ScanSearch size={24} aria-hidden="true" className="platform-testing__kind-icon" />
            <strong className="platform-testing__kind-title">Поиск по фото</strong>
            <p className="platform-testing__note platform-testing__kind-text">
              Тестовые товары с эталонами и кадрами, проверка кадра тем же путём, что боевой поиск, и замеры: место нужного товара по каждой дорожке и после
              слияния.
            </p>
            <div className="platform-testing__kind-action">
              <Button
                icon={<ScanSearch size={16} aria-hidden="true" />}
                aria-label="Открыть поиск по фото"
                onClick={actions.openPhotoSearch}
                actionId="platform.testing.open-photo-search"
              >
                Открыть
              </Button>
            </div>
          </li>
          <li>
            <TextSearch size={24} aria-hidden="true" className="platform-testing__kind-icon" />
            <strong className="platform-testing__kind-title">Поиск по тексту</strong>
            <p className="platform-testing__note platform-testing__kind-text">
              Запросы к тестовым товарам — название, часть, опечатка, раскладка, артикул, штрихкод; проверка запроса тем же путём, что номенклатура, и
              замеры по видам запросов и по тому, чем нашёлся товар.
            </p>
            <div className="platform-testing__kind-action">
              <Button
                icon={<TextSearch size={16} aria-hidden="true" />}
                aria-label="Открыть поиск по тексту"
                onClick={actions.openTextSearch}
                actionId="platform.testing.open-text-search"
              >
                Открыть
              </Button>
            </div>
          </li>
          <li>
            <Copy size={24} aria-hidden="true" className="platform-testing__kind-icon" />
            <strong className="platform-testing__kind-title">Похожие варианты</strong>
            <p className="platform-testing__note platform-testing__kind-text">
              Двойники — товары одной серии, которые отличаются словом или числом. Семейства из каталога, кадры каждого варианта и замер: не выдаёт ли поиск
              двойника вместо нужного товара.
            </p>
            <div className="platform-testing__kind-action">
              <Button
                icon={<Copy size={16} aria-hidden="true" />}
                aria-label="Открыть похожие варианты"
                onClick={actions.openTwin}
                actionId="platform.testing.open-twin"
              >
                Открыть
              </Button>
            </div>
          </li>
        </ul>
      </section>
    </TestingGate>
  )
}
